"use client";
import { SelectButton } from "@/components/Elements/SelectButton";
import { SubTypeLabels, SubTypesEnums } from "@/constants/enums";
import { PhotoSubtype } from "@/interfaces/galleries/Galleries";
import React from "react";

interface PropsSubtype {
  selected?: PhotoSubtype | "all";
  onClick: (value: PhotoSubtype | "all") => void;
  all?: boolean;
}
export const SubTypesSelect = ({ selected, onClick, all }: PropsSubtype) => {
  const currentValue = selected || (all ? "all" : SubTypesEnums.regular);
  return (
    <>
      {all ? (
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => {
            onClick("all");
          }}
        >
          <SelectButton selected={currentValue === "all"} />
          <p>All</p>
        </div>
      ) : (
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => {
            onClick("regular");
          }}
        >
          <SelectButton selected={currentValue === SubTypesEnums.regular} />
          <p>{SubTypeLabels.regular}</p>
        </div>
      )}
      <div
        className="flex gap-2 items-center cursor-pointer"
        onClick={() => {
          onClick("cool/rare");
        }}
      >
        <SelectButton selected={currentValue === SubTypesEnums["cool/rare"]} />
        <p>{SubTypeLabels["cool/rare"]}</p>
      </div>
      <div
        className="flex gap-2  items-center cursor-pointer"
        onClick={() => {
          onClick("exclusive");
        }}
      >
        <SelectButton selected={currentValue === SubTypesEnums.exclusive} />
        <p>{SubTypeLabels.exclusive}</p>
      </div>
    </>
  );
};
